module.exports = __webpack_public_path__ + "files/4586e45b1944e8c93dd93eca1f1e17e4.png";